import { createTranslationRef } from '@backstage/frontend-plugin-api';

export const doraMetricsDefaultTitle = 'DORA Metrics';

export const doraMetricsTranslationRef = createTranslationRef({
  id: 'dora-metrics',
  messages: {
    title: doraMetricsDefaultTitle,
    loading: {
      subtitle: 'Metrics',
      establishingRoutes: 'Establishing routes...',
      syncingCatalog: 'Syncing catalog...',
      loadingPlugins: 'Loading plugins...',
      fetchingPrData: 'Fetching MR data...',
      readingEntityGraph: 'Reading entity graph...',
    },
    dates: {
      locale: 'en-US',
      lastDays: 'Last {{days}} days',
    },
    duration: {
      dayShort: 'd',
      hourShort: 'h',
      minuteShort: 'm',
    },
    rating: {
      elite: 'elite',
      high: 'high',
      medium: 'medium',
      low: 'low',
    },
    delta: {
      improving: 'improving',
      worsening: 'worsening',
      perWeekShort: 'wk',
      tooltip:
        'Latest period: {{current}} · Previous period: {{previous}}\nEach period = one time bucket (~1/7th of your selected date range)',
    },
    errors: {
      label: 'Error:',
      missingAnnotation: 'Entity is missing the "{{annotation}}" annotation.',
      noEnvironments: 'No environments configured for DORA metrics.',
      accessDenied: {
        title: 'DORA Metrics access is restricted',
        description:
          'Reason: check your permissions or contact an administrator.',
      },
    },
    filters: {
      environment: 'Environment',
      dateRange: 'Date Range',
      selectEnvironment: 'Select environment',
      selectDateRange: 'Select date range',
    },
    header: {
      showingMetricsFor: 'Showing metrics for',
    },
    metric: {
      targetLower: 'Target: < {{value}} {{unit}}',
      targetHigher: 'Target: ≥ {{value}} {{unit}}',
      expand: 'expand ↗',
      lowerBetter: '↓ lower = better',
      higherBetter: '↑ higher = better',
      deploymentFrequency: {
        title: 'Deployment Frequency',
        description: 'How often code is deployed to this branch',
        tooltip:
          'How often changes are merged into the configured environment branch. In this implementation, each merged MR is treated as one deployment and normalized to deployments per week. Note: this is an MR-based approximation and does not yet use Argo CD deployment status.',
      },
      leadTimeForChanges: {
        title: 'Lead Time for Changes',
        description: 'Average time from MR creation to merge',
        tooltip:
          'Average time from MR creation to merge commit creation for MRs merged into the selected branch. This measures how long a change takes to get merged, not how long it takes to reach the runtime environment.',
      },
      changeFailureRate: {
        title: 'Change Failure Rate',
        description: '% of all merged MRs that were hotfixes',
        tooltip:
          'Percentage of merged production MRs that match the configured failure label pattern, for example hotfix or срочный фикс. Note: this is label-based and does not yet detect real Argo CD deployment failures.',
      },
      meanTimeToRestore: {
        title: 'Mean Time to Restore',
        description: 'Avg time from hotfix MR open to merge',
        tooltip:
          'Average time from opening a labeled hotfix MR to merging it into the production branch. Note: this is an approximation and does not yet measure the actual time from production failure detection to service recovery.',
      },
      hotfixesToProduction: {
        title: 'Hotfixes to Production',
        defaultLabel: 'hotfix',
        description: "MRs labeled '{{label}}' merged to production",
        expandLabel: 'View {{value}} MR{{plural}} →',
        tooltip:
          'Number of production MRs merged during the selected period that match the configured hotfix/failure label pattern, for example hotfix, срочный фикс, or a regex/list from configuration. Lower is better; zero means no labeled production hotfixes were merged.',
      },
      productionOnly: 'Only tracked on production branches',
    },
    details: {
      notEnoughData: 'Not enough data — select a wider date range.',
      allDeployments: 'All deployments',
      allHotfixes: 'All hotfixes',
      prCount: '{{value}} MR{{plural}}',
      leadSuffix: '{{duration}} lead',
      slowestHotfixPrs: 'Slowest Hotfix MRs',
      slowestPrs: 'Slowest MRs',
      hoverRowToHighlight: 'hover a row to highlight on chart',
    },
  },
  translations: {},
});
